import React from 'react';

import { Search } from '@videoblocks/react-icons';

import ConversationalSearchButton from './ConversationalSearchButton';

/**
 * Trailing controls for the `button` arm of the conversational-search discoverability experiment:
 * a plain magnifying-glass submit (standard search) next to the dedicated Conversational Search CTA.
 * Shared by both ProminentSearch surfaces so the layout stays identical between them.
 */
export default function ConversationalSearchSubmit({
  disabledForContentType,
  onConversationalSearch,
}: {
  disabledForContentType: boolean;
  onConversationalSearch: () => void;
}): React.ReactElement {
  return (
    <>
      <button
        type="submit"
        aria-label="Submit Search"
        className="hidden md:flex flex-shrink-0 flex-grow-0 items-center justify-center border-none bg-transparent px-2 cursor-pointer"
      >
        <Search className="w-4 h-4 fill-gray-700" />
      </button>
      <ConversationalSearchButton
        disabledForContentType={disabledForContentType}
        onClick={onConversationalSearch}
      />
    </>
  );
}
